import { Routes } from '@angular/router';
import { SidenavContentComponent } from './shared/sidenav-content/sidenav-content.component';
import { SigninComponent } from './signin/signin.component';
import { ViewSlabsComponent } from './view-slabs/view-slabs.component';
import { ViewIncentivesComponent } from './view-incentives/view-incentives.component';
import { IAllocatorIncentiveComponent } from './i-allocator-incentive/i-allocator-incentive.component';
import { CreateIncentiveComponent } from './create-incentive/create-incentive.component';
import { AuthGuardService } from './auth-guard.service';
import { PenaltyRewardCampaignComponent } from './penalty-reward-campaign/penalty-reward-campaign.component';
import { ViewCampaignsComponent } from './view-campaigns/view-campaigns.component';
import { ViewIncentiveComponent } from './view-incentive/view-incentive.component';
import { BulkPayInitiateComponent } from './bulkpay/initiate/initiate.component';
import { BulkPayHistoryComponent } from './bulkpay/history/history.component';
import { AUDIT_CAMPAIGN_INITIATE, BULK_PAY_APPROVALS, BULK_PAY_HISTORY, BULK_PAY_INITIATE, CREATE_SUBSCRIPTION, LIST_ACCESS_FEE_PLANS, LIST_BILLING_PLAN_REQUESTS, LIST_SUBSCRIPTION_REQUESTS, LIST_SUBSCRIPTIONS, VIEW_ACCESS_FEE_PLAN, VIEW_BILLING_PLAN_REQUEST, VIEW_SUBSCRIPTION, VIEW_SUBSCRIPTION_REQUEST, BULK_CREATE_SUBSCRIPTION, CREATE_SHIFT, CREATE_SLAB, CREATE_GEO_SLAB, VIEW_SLAB, DUPLICATE_SLAB, LIST_REDEEMS, CREATE_REDEEM, EDIT_REDEEM, CREATE_LIMIT_STORE, LIST_LIMIT_STORE, LIST_LIMIT_APPROVALS } from './routes';
import { RedeemListComponent } from './redeem/list/redeem-list.component';
import { RedeemCreateComponent } from './redeem/create/redeem-create.component';
import { LimitStoreCreateComponent } from './limit-store/create/limit-store-create.component';
import { LimitStoreListComponent } from './limit-store/list/limit-store-list.component';
import { MakerCheckerApprovalsComponent } from './shared/maker-checker/maker-checker-approvals.component';
import { SubscriptionComponent } from './subscription/subscription.component';
import { BulkCreateSubscriptionComponent } from './subscription/bulk-subscription/bulk.subscription.create.component';
import { AuditCampaignInitiateComponent } from './penalty-reward-campaign/audit-campaign/audit-campaign.component';
import { IAllocatorConstructUploadComponent } from './i-allocator-incentive/construct-upload/construct-upload.component';
import { ListSubscriptionsComponent } from './subscription/prepaid/list/list.component';
import { ViewSubscriptionRuleComponent } from './subscription/prepaid/view/view.component';
import { ViewAccessFeeComponent } from './subscription/accessFee/view/view.component';
import { ListAccessFeeComponent } from './subscription/accessFee/list/accessFee.list.component';
import { ConfigRequestListComponent } from './subscription/config-requests/list.component';
import { ConfigRequestViewComponent } from './subscription/config-requests/view.component';
import { CreateShiftComponent } from './shift/create-shift/create-shift.component';
import { CreateSlabComponent } from './create-slab/create-slab.component';
import { IncentiveApprovalRequestsComponent } from './incentive-approval-requests/incentive-approval-requests.component';
import { INCENTIVE_APPROVAL_REQUESTS, SLAB_APPROVAL_REQUESTS } from './routes';
import { AUTHZ_FEATURES } from './constants/permissions';
import { SlabApprovalRequestsComponent } from './slab-approval-requests/slab-approval-requests.component';
import { HomeComponent } from './home/home.component';
var ɵ0 = { permissionActions: ['edit'], feature: AUTHZ_FEATURES.INCENTIVE }, ɵ1 = { permissionActions: ['view'], feature: AUTHZ_FEATURES.SLAB }, ɵ2 = {
    permissionActions: ['view', 'create', 'approve'],
    feature: AUTHZ_FEATURES.SLAB
}, ɵ3 = {
    permissionActions: ['view', 'create', 'approve'],
    feature: AUTHZ_FEATURES.SLAB
}, ɵ4 = {
    permissionActions: ['view', 'edit', 'approve'],
    feature: AUTHZ_FEATURES.INCENTIVE,
}, ɵ5 = {
    permissionActions: ['view', 'edit', 'approve'],
    feature: AUTHZ_FEATURES.INCENTIVE,
}, ɵ6 = {
    permissionActions: ['view', 'edit', 'approve'],
    feature: AUTHZ_FEATURES.INCENTIVE,
}, ɵ7 = {
    permissionActions: ['view', 'edit', 'approve'],
    feature: AUTHZ_FEATURES.INCENTIVE,
}, ɵ8 = { permissionActions: ['edit'], feature: AUTHZ_FEATURES.INCENTIVE }, ɵ9 = { permission: 'edit_penalty_reward' }, ɵ10 = { permission: 'view_penalty_reward' }, ɵ11 = { permissionActions: ['edit'], feature: AUTHZ_FEATURES.INCENTIVE }, ɵ12 = { permission: 'iallocator_construct_upload' }, ɵ13 = { permission: 'view_penalty_reward' }, ɵ14 = { permission: 'edit_audit_campaign' }, ɵ15 = { permissionActions: ['create'], feature: AUTHZ_FEATURES.BULK_PAY }, ɵ16 = { permissionActions: ['view'], feature: AUTHZ_FEATURES.BULK_PAY }, ɵ17 = {
    permissionActions: ['view', 'create', 'approve'],
    feature: AUTHZ_FEATURES.BULK_PAY,
    entityType: 'BULK_PAY',
    title: 'Bulk Payment Approvals',
    changeLabel: 'bulk payment',
    approvalsApi: '/api/bulkpay/approvals',
    payloadFields: [
        { key: 'subTransactionType', label: 'Type' },
        { key: 'remarks', label: 'Remarks' },
        { key: 'comment', label: 'Comment' },
        { key: 'transactions', label: 'Rows' }
    ]
}, ɵ18 = { permissionActions: ['create'], feature: AUTHZ_FEATURES.SUBSCRIPTION }, ɵ19 = { permissionActions: ['view'], feature: AUTHZ_FEATURES.SUBSCRIPTION }, ɵ20 = { permissionActions: ['view'], feature: AUTHZ_FEATURES.BILLING_PLANS }, ɵ21 = { permissionActions: ['view'], feature: AUTHZ_FEATURES.SUBSCRIPTION }, ɵ22 = { permissionActions: ['view'], feature: AUTHZ_FEATURES.BILLING_PLANS }, ɵ23 = {
    kind: 'subscription',
    title: 'Subscription Requests',
    permissionActions: ['view', 'approve'],
    feature: AUTHZ_FEATURES.SUBSCRIPTION,
    allowWhenPanelOff: true,
}, ɵ24 = {
    kind: 'subscription',
    permissionActions: ['view', 'approve'],
    feature: AUTHZ_FEATURES.SUBSCRIPTION,
    allowWhenPanelOff: true,
}, ɵ25 = {
    kind: 'billingPlan',
    title: 'Access Fee Requests',
    permissionActions: ['view', 'approve'],
    feature: AUTHZ_FEATURES.BILLING_PLANS,
    allowWhenPanelOff: true,
}, ɵ26 = {
    kind: 'billingPlan',
    permissionActions: ['view', 'approve'],
    feature: AUTHZ_FEATURES.BILLING_PLANS,
    allowWhenPanelOff: true,
}, ɵ27 = { permissionActions: ['create'], feature: AUTHZ_FEATURES.SUBSCRIPTION }, ɵ28 = { permissionActions: ['create'], feature: AUTHZ_FEATURES.SLAB }, ɵ29 = { permissionActions: ['create'], feature: AUTHZ_FEATURES.SLAB }, ɵ30 = { permissionActions: ['createGeoSlab'], geoSlab: true, feature: AUTHZ_FEATURES.SLAB }, ɵ31 = { permissionActions: ['view'], feature: AUTHZ_FEATURES.SLAB }, ɵ32 = { permissionActions: ['create'], feature: AUTHZ_FEATURES.SLAB }, ɵ33 = { permission: 'redeem_list' }, ɵ34 = { permission: 'redeem_add' }, ɵ35 = { permission: 'redeem_edit' }, ɵ36 = {
    permissionActions: ['view', 'edit', 'approve'],
    feature: AUTHZ_FEATURES.LIMIT_STORE,
}, ɵ37 = {
    permissionActions: ['view', 'edit', 'approve', 'approvalView'],
    feature: AUTHZ_FEATURES.LIMIT_STORE,
    entityType: 'LIMIT',
    title: 'Limit Approvals',
    payloadFields: [
        { key: 'city', label: 'City' },
        { key: 'identifier', label: 'Identifier' },
        { key: 'identifierId', label: 'Name' },
        { key: 'limitType', label: 'Limit type' },
        { key: 'limit', label: 'Limit' },
        { key: 'warning', label: 'Warning' },
        { key: 'priority', label: 'Priority' },
        { key: 'active', label: 'Active' }
    ]
}, ɵ38 = { permissionActions: ['edit'], feature: AUTHZ_FEATURES.LIMIT_STORE };
var routes = [
    {
        path: 'login',
        component: SigninComponent
    },
    {
        path: '',
        canActivate: [AuthGuardService],
        component: SidenavContentComponent,
        children: [
            {
                path: '',
                pathMatch: 'full',
                component: HomeComponent,
            },
            {
                path: 'createIncentive',
                canActivate: [AuthGuardService],
                component: CreateIncentiveComponent,
                data: ɵ0
            },
            {
                path: 'slabs',
                canActivate: [AuthGuardService],
                component: ViewSlabsComponent,
                data: ɵ1
            },
            {
                path: SLAB_APPROVAL_REQUESTS,
                canActivate: [AuthGuardService],
                component: SlabApprovalRequestsComponent,
                data: ɵ2
            },
            {
                path: SLAB_APPROVAL_REQUESTS + "/:requestId",
                canActivate: [AuthGuardService],
                component: CreateSlabComponent,
                data: ɵ3
            },
            {
                path: 'incentives',
                canActivate: [AuthGuardService],
                component: ViewIncentivesComponent,
                data: ɵ4
            },
            {
                path: INCENTIVE_APPROVAL_REQUESTS,
                canActivate: [AuthGuardService],
                component: IncentiveApprovalRequestsComponent,
                data: ɵ5
            },
            {
                path: INCENTIVE_APPROVAL_REQUESTS + "/:incentiveId",
                canActivate: [AuthGuardService],
                component: ViewIncentiveComponent,
                data: ɵ6
            },
            {
                path: 'viewIncentive/:incentiveId/:action',
                canActivate: [AuthGuardService],
                component: ViewIncentiveComponent,
                runGuardsAndResolvers: 'always',
                data: ɵ7,
            },
            {
                path: 'incentive/:incentiveId/:action',
                canActivate: [AuthGuardService],
                component: CreateIncentiveComponent,
                runGuardsAndResolvers: 'always',
                data: ɵ8,
            },
            {
                path: 'penalty-reward-campaign',
                children: [{
                        path: 'create',
                        component: PenaltyRewardCampaignComponent,
                    }],
                canActivate: [AuthGuardService],
                data: ɵ9
            },
            {
                path: 'campaigns',
                component: ViewCampaignsComponent,
                canActivate: [AuthGuardService],
                data: ɵ10
            },
            {
                path: 'newIncentive',
                canActivate: [AuthGuardService],
                component: IAllocatorIncentiveComponent,
                data: ɵ11
            },
            {
                path: 'uploadConstruct',
                canActivate: [AuthGuardService],
                component: IAllocatorConstructUploadComponent,
                data: ɵ12
            },
            {
                path: 'campaign/:campaignId/:status/:action',
                component: PenaltyRewardCampaignComponent,
                data: ɵ13
            },
            {
                path: AUDIT_CAMPAIGN_INITIATE,
                canActivate: [AuthGuardService],
                component: AuditCampaignInitiateComponent,
                data: ɵ14
            },
            {
                path: BULK_PAY_INITIATE,
                canActivate: [AuthGuardService],
                component: BulkPayInitiateComponent,
                data: ɵ15
            },
            {
                path: BULK_PAY_HISTORY,
                canActivate: [AuthGuardService],
                component: BulkPayHistoryComponent,
                data: ɵ16
            },
            {
                path: BULK_PAY_APPROVALS,
                canActivate: [AuthGuardService],
                component: MakerCheckerApprovalsComponent,
                data: ɵ17
            },
            {
                path: CREATE_SUBSCRIPTION,
                canActivate: [AuthGuardService],
                component: SubscriptionComponent,
                data: ɵ18
            },
            {
                path: LIST_SUBSCRIPTIONS,
                canActivate: [AuthGuardService],
                component: ListSubscriptionsComponent,
                data: ɵ19
            },
            {
                path: LIST_ACCESS_FEE_PLANS,
                canActivate: [AuthGuardService],
                component: ListAccessFeeComponent,
                data: ɵ20
            },
            {
                path: VIEW_SUBSCRIPTION,
                canActivate: [AuthGuardService],
                component: ViewSubscriptionRuleComponent,
                data: ɵ21
            },
            {
                path: VIEW_ACCESS_FEE_PLAN,
                canActivate: [AuthGuardService],
                component: ViewAccessFeeComponent,
                data: ɵ22
            },
            {
                path: LIST_SUBSCRIPTION_REQUESTS,
                canActivate: [AuthGuardService],
                component: ConfigRequestListComponent,
                data: ɵ23
            },
            {
                path: VIEW_SUBSCRIPTION_REQUEST,
                canActivate: [AuthGuardService],
                component: ConfigRequestViewComponent,
                data: ɵ24
            },
            {
                path: LIST_BILLING_PLAN_REQUESTS,
                canActivate: [AuthGuardService],
                component: ConfigRequestListComponent,
                data: ɵ25
            },
            {
                path: VIEW_BILLING_PLAN_REQUEST,
                canActivate: [AuthGuardService],
                component: ConfigRequestViewComponent,
                data: ɵ26
            },
            {
                path: BULK_CREATE_SUBSCRIPTION,
                canActivate: [AuthGuardService],
                component: BulkCreateSubscriptionComponent,
                data: ɵ27
            },
            {
                path: CREATE_SHIFT,
                canActivate: [AuthGuardService],
                component: CreateShiftComponent,
                data: ɵ28
            },
            {
                path: CREATE_SLAB,
                canActivate: [AuthGuardService],
                component: CreateSlabComponent,
                data: ɵ29
            },
            {
                path: CREATE_GEO_SLAB,
                canActivate: [AuthGuardService],
                component: CreateSlabComponent,
                data: ɵ30
            },
            {
                path: VIEW_SLAB,
                canActivate: [AuthGuardService],
                component: CreateSlabComponent,
                runGuardsAndResolvers: 'always',
                data: ɵ31
            },
            {
                path: DUPLICATE_SLAB,
                canActivate: [AuthGuardService],
                component: CreateSlabComponent,
                data: ɵ32,
            },
            {
                path: LIST_REDEEMS,
                canActivate: [AuthGuardService],
                component: RedeemListComponent,
                data: ɵ33
            },
            {
                path: CREATE_REDEEM,
                canActivate: [AuthGuardService],
                component: RedeemCreateComponent,
                data: ɵ34
            },
            {
                path: EDIT_REDEEM,
                canActivate: [AuthGuardService],
                component: RedeemCreateComponent,
                runGuardsAndResolvers: 'always',
                data: ɵ35
            },
            {
                path: LIST_LIMIT_STORE,
                canActivate: [AuthGuardService],
                component: LimitStoreListComponent,
                data: ɵ36
            },
            {
                path: LIST_LIMIT_APPROVALS,
                canActivate: [AuthGuardService],
                component: MakerCheckerApprovalsComponent,
                data: ɵ37
            },
            {
                path: CREATE_LIMIT_STORE,
                canActivate: [AuthGuardService],
                component: LimitStoreCreateComponent,
                data: ɵ38
            }
        ]
    },
];
var AppRoutingModule = /** @class */ (function () {
    function AppRoutingModule() {
    }
    return AppRoutingModule;
}());
export { AppRoutingModule };
export { ɵ0, ɵ1, ɵ2, ɵ3, ɵ4, ɵ5, ɵ6, ɵ7, ɵ8, ɵ9, ɵ10, ɵ11, ɵ12, ɵ13, ɵ14, ɵ15, ɵ16, ɵ17, ɵ18, ɵ19, ɵ20, ɵ21, ɵ22, ɵ23, ɵ24, ɵ25, ɵ26, ɵ27, ɵ28, ɵ29, ɵ30, ɵ31, ɵ32, ɵ33, ɵ34, ɵ35, ɵ36, ɵ37, ɵ38 };
